/**
 * Что показать внутри Блока (тикет T18b, спецификация § 3, § 10).
 *
 * Типов Блоков дюжина, а на сайте пока живут не все. Молча показывать пустую рамку нельзя:
 * пустой Блок неотличим от сломанного, и человек будет ждать, пока «догрузится». Поэтому
 * тот, кого мы ещё не нарисовали, честно говорит об этом словами — ровно как Блок с
 * отвалившимся сервисом (§ 10).
 */
import type { ReactNode } from 'react';
import type { Block } from '@core/layout/editor.js';
import type { Api, Member } from '../net/api.js';
import { Conversation } from './Conversation.js';
import { Tasks } from './Tasks.js';
import { useT } from '../state/settings.js';

/**
 * Типы Блоков, у которых на сайте уже есть содержимое. Список один и живёт рядом с самим
 * показом: разойдись он с `BlockBody`, каталог обещал бы человеку работающий Блок, а тот
 * встал бы заглушкой — ровно та беда, из-за которой список и заведён (правка 2026-08-27).
 */
export const READY_BLOCK_KINDS: ReadonlySet<string> = new Set(['conversation', 'tasks']);

export function BlockBody({
  block,
  api,
  channelId,
  members,
  meId,
  onRead,
}: {
  readonly block: Block;
  readonly api: Api;
  /** Канал, на экране которого стоит Блок. Заготовка Пространства Канала не имеет. */
  readonly channelId: string | null;
  readonly members: readonly Member[];
  /** Кто смотрит: своё Сообщение можно поправить и убрать, чужое — нет. */
  readonly meId?: string | undefined;
  /** «Дочитано, осталось столько-то» — уходит в счётчик рядом с Каналом. */
  readonly onRead?: ((channelId: string, unread: number) => void) | undefined;
}): ReactNode {
  const t = useT();

  if (block.kind === 'conversation' && channelId) {
    return (
      <Conversation
        api={api}
        channelId={channelId}
        members={members}
        meId={meId}
        onRead={onRead}
      />
    );
  }
  if (block.kind === 'tasks') return <Tasks api={api} />;

  return <p className="text-ink-soft">{t('block.notReady')}</p>;
}
